module.exports = __webpack_public_path__ + "img/aff-mrk.bd671543.svg";